<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { create } from '@/routes/hearing-assessment';
import LandingNav from './LandingNav.vue';

defineProps<{
    content: Record<string, string | null>;
}>();
</script>

<template>
    <section
        class="relative min-h-[852px] overflow-hidden bg-primary md:min-h-[816px]"
    >
        <video
            autoplay
            loop
            muted
            playsinline
            class="absolute inset-0 size-full object-cover opacity-30"
            src="https://resonate.sgp1.cdn.digitaloceanspaces.com/HR_Resonate%20Ear_PP.mp4"
        />

        <div class="relative z-10">
            <LandingNav />

            <div
                class="flex min-h-[calc(100vh-80px)] md:min-h-0 flex-col items-center px-4 pt-8 pb-6 text-center md:px-6"
            >
                <!-- Logo -->
                <img
                    src="/images/landing/logo.svg"
                    alt="Rate Your Hearing - powered by Resonate"
                    class="mb-8 h-[50px] w-[225px] md:mb-12 md:h-[54px] md:w-[243px]"
                />

                <!-- Heading -->
                <h1
                    class="max-w-[352px] whitespace-pre-line font-serif text-[42px] leading-[50px] text-white md:max-w-[878px] md:text-[64px] md:leading-[82px]"
                >
                    {{ content['hero.heading'] }}
                </h1>

                <!-- Description -->
                <p
                    class="mt-4 max-w-[352px] text-base leading-6 text-white md:max-w-[616px]"
                >
                    {{ content['hero.description'] }}
                </p>

                <!-- CTA Button -->
                <Link
                    :href="create().url"
                    class="mt-9 inline-flex h-[72px] w-full items-center justify-center rounded-full bg-accent text-xl font-medium text-accent-foreground transition-opacity hover:opacity-90 md:mt-10 md:w-[369px]"
                >
                    {{ content['hero.cta_label'] }}
                </Link>

                <!-- Spacer -->
                <div class="md:hidden flex min-h-0 grow"></div>

                <!-- Mobile Nav -->
                <nav
                    class="w-full px-4 py-5 text-sm text-white md:hidden md:px-14 md:py-12 md:text-base"
                >
                    <div class="flex items-center justify-between gap-6">
                        <a
                            :href="content['hero.mobile_phone_href'] ?? ''"
                            class="underline"
                            >{{ content['hero.mobile_phone_label'] }}</a
                        >
                        <a
                            :href="content['hero.mobile_email_href'] ?? ''"
                            class="underline"
                            >{{ content['hero.mobile_email_label'] }}</a
                        >
                    </div>
                </nav>
            </div>
        </div>
    </section>
</template>
